// src/components/PendingGroupMembers.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function PendingGroupMembers({ groupId }) {
  const [pending, setPending] = useState([]);
  const [message, setMessage] = useState('');

  const fetchPending = async () => {
    try {
      const res = await axios.get(`http://localhost:5000/api/groups/${groupId}/members`);
      const allMembers = res.data.members;

      // Group unapproved memberships by user_id
      const grouped = {};
      allMembers.forEach(m => {
        if (m.is_approved_by_organiser === 0) {
          if (!grouped[m.user_id]) {
            grouped[m.user_id] = {
              user_id: m.user_id,
              email: m.email,
              first_name: m.given_name,
              last_name: m.surname,
              count: 1,
              approve_count: 1
            };
          } else {
            grouped[m.user_id].count++;
            grouped[m.user_id].approve_count++;
          }
        }
      });

      setPending(Object.values(grouped));
    } catch (err) {
      setMessage('Failed to load pending members');
    }
  };

  const updateApproveCount = (userId, count) => {
    setPending(prev =>
      prev.map(user =>
        user.user_id === userId
          ? { ...user, approve_count: Math.min(Math.max(count, 1), user.count) }
          : user
      )
    );
  };

  const approve = async (userId, approveCount) => {
    try {
      await axios.post(`http://localhost:5000/api/groups/${groupId}/approve-member`, {
        user_id: userId,
        approve_count: approveCount
      });
      setMessage(`✅ Approved ${approveCount} memberships for ${userId}`);
      fetchPending();
    } catch {
      setMessage('Approval failed');
    }
  };

  const reject = async (userId) => {
    try {
      await axios.delete(`http://localhost:5000/api/groups/${groupId}/reject-member/${userId}`);
      setMessage(`❌ Rejected all memberships for ${userId}`);
      fetchPending();
    } catch {
      setMessage('Rejection failed');
    }
  };

  useEffect(() => {
    fetchPending();
  }, [groupId]);

  return (
    <div className="card">
      <h3>Pending Membership Approvals</h3>
      {message && <p>{message}</p>}
      <ul>
        {pending.map(user => (
          <li key={user.user_id} style={{ marginBottom: '15px' }}>
            <strong>{user.first_name} {user.last_name}</strong> ({user.email})<br />
            <em>{user.count} membership{user.count > 1 ? 's' : ''} pending</em><br />
            <label>
              Approve:
              <input
                type="number"
                value={user.approve_count}
                min="1"
                max={user.count}
                onChange={(e) =>
                  updateApproveCount(user.user_id, parseInt(e.target.value || '1'))
                }
                style={{ width: '50px', marginLeft: '8px' }}
              />
            </label>
            <button onClick={() => approve(user.user_id, user.approve_count)} style={{ marginLeft: '10px' }}>
              ✅ Approve
            </button>
            <button
              onClick={() => reject(user.user_id)}
              style={{ marginLeft: '10px', backgroundColor: 'red', color: 'white' }}
            >
              ❌ Reject All
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
